<template>
  <div class="userguide">
    <div class="guide">
      <div class="guide_w">
        <div class="tit">Hi DO community members!</div>
        <div class="box">
          <div class="boxtit">
            This is a guide for you to explore the DO network. You will know how
            to earn from DO, and how to get familiar with DO, and how to
            participate in DO.
          </div>
          <div class="boxtit1">
            No matter if you know about technology, no matter if you are a
            newcomer or a master, this article will help!
          </div>
          <div class="boxtit3">
            <div class="tits">Now, let&#39;s start our journey</div>
            <img src="../../../assets/pc/user/down.png" />
          </div>
        </div>
        <div class="guidenum">
          <div class="num">No 1</div>
          <div class="numtit">Explore Sunny Wallet</div>
        </div>
      </div>
    </div>
    <div class="guide1">
      <div class="guide1-w">
        <div class="guideul">
          <div class="guideli" style="padding-bottom: 0px">
            <div class="litit1">
              <div class="step">1</div>
              <div class="steptit">Create your wallet</div>
            </div>
            <div class="litit2">
              Sunny Wallet is the main entrance of DO network, also your
              starting<br />
              point.If you are a newcomer, after you download the latest
              version<br />
              and install, create a new wallet.
            </div>
            <div class="litit3" style="width: 403px">
              Backup your Mnemonics, remember not to tell anyone
            </div>
            <img src="../../../assets/pc/user/1a.png" />
          </div>
          <div class="guideli" style="padding-bottom: 0px">
            <div class="litit1">
              <div class="step">2</div>
              <div class="steptit">Get DO in your wallet</div>
            </div>
            <div class="litit2">
              After creating your wallet, you can see your assets. If you don&#39;t
              have<br />
              any DO yet, you can buy some at Hotcoin and withdraw to your<br />
              wallet, or follow our social media and participate in our
              airdrop<br />
              campaigns to get some.
            </div>

            <img src="../../../assets/pc/user/1b.png" />
          </div>
          <div class="guideli">
            <div class="litit1">
              <div class="step">3</div>
              <div class="steptit">Try investing</div>
            </div>
            <div class="litit2">
              Click “Invest” in your Sunny wallet, choose a node that hasn&#39;t
              reached<br />
              100% yet to invest in.
            </div>
            <div class="litit3">
              Then you can enjoy an APY up to 10%! It is that easy!
            </div>
            <img
              src="../../../assets/pc/user/1c.png"
              style="width: 312px; height: 246px"
            />
          </div>
        </div>
        <div class="guidenum">
          <div class="num">No 2</div>
          <div class="numtit">Explore DO chain</div>
        </div>
        <div class="guidetit">
          DO has a strong explorer to make it possible for everyone to check all
          the public data on chain. It is comprehensive and easy to use.
        </div>
        <div class="guideul" style="margin-top: 24px">
          <div class="guideli" style="width: 1190px">
            <div class="litit1">
              <div class="step">1</div>
              <div class="steptit">Total view</div>
            </div>
            <div class="litit2">
              In the official website, click “Explore DO Network”-“DO EXPLORER”
              on the right top corner, then you can enter the DO explorer, and
              you can see everything on<br />
              the DO chain.
            </div>
            <!-- <div class="litit3" style="width: 403px">
              Backup your Mnemonics, remember not to tell anyone
            </div> -->
            <img src="../../../assets/pc/user/2a.png" class="img1" />
          </div>
          <div class="guideli" style="width: 1190px">
            <div class="litit1">
              <div class="step">2</div>
              <div class="steptit">Check your address</div>
            </div>
            <div class="litit2">
              You can enter your address (or any other address) in the search
              bar, thus you can check the assets, the transactions and other
              information about this<br />
              address.
            </div>

            <img src="../../../assets/pc/user/2b.png" class="img2" />
          </div>
          <div class="guideli" style="width: 1190px">
            <div class="litit1">
              <div class="step">3</div>
              <div class="steptit">Check the validators</div>
            </div>
            <div class="litit2">
              Click “Validators” on the right top area and you can see the
              validator list. You can check the informations of each validator
              to decide which validator to<br />
              delegate to.
            </div>

            <img src="../../../assets/pc/user/2c.png" class="img3" />
          </div>
          <div class="guideli" style="width: 1190px">
            <div class="litit1">
              <div class="step">4</div>
              <div class="steptit">Create your own coin</div>
            </div>
            <div class="litit2">
              Do you want to create your own coin on DO network? It is so easy!
              Click “More”-”Contract Deployment”-“No-Code Contract Deployment”.
            </div>

            <img src="../../../assets/pc/user/2d.png" class="img4" />
            <div class="litit2">
              Then enter the basic information of your coin, and confirm.
            </div>
            <img src="../../../assets/pc/user/2e.png" class="img5" />
            <div class="litit3" style="width: 305px">
              Thus you now have your own coin! Try it!
            </div>
          </div>
        </div>
        <div class="guidenum">
          <div class="num">No 3</div>
          <div class="numtit">Explore DO community</div>
        </div>
        <div class="guidetit">
          DO has a strong community where you can communicate with DO community
          members from all over the world.
        </div>
        <div class="litit3" style="width: 661px">
          Click “Community” to check on the right top corner of the main page of
          the official website.
        </div>
        <div class="guideul" style="margin-top: 24px">
          <div class="guideli" style="width: 1190px">
            <div class="litit1">
              <div class="step">1</div>
              <div class="steptit">Twitter/X</div>
            </div>
            <div class="litit2">
              You can find all official links of DO and pay attention to our
              pinned tweet to follow the latest campaign.
            </div>
            <!-- <div class="litit3" style="width: 403px">
              Backup your Mnemonics, remember not to tell anyone
            </div> -->
            <img src="../../../assets/pc/user/3a.png" class="img3a1" />
          </div>
          <div class="guideli" style="width: 1190px">
            <div class="litit1">
              <div class="step">2</div>
              <div class="steptit">Discord</div>
            </div>
            <div class="litit2">
              The discord is divided into different channels and you can easily
              find the information you want.
            </div>

            <img src="../../../assets/pc/user/3b.png" class="img3a2" />
          </div>
          <div class="guideli" style="width: 1190px">
            <div class="litit1">
              <div class="step">3</div>
              <div class="steptit">Galxe/Zealy</div>
            </div>
            <div class="litit2">
              We keep holding campaigns on these task platforms and keep an eye
              on it!
            </div>
          </div>
        </div>
        <div class="guibg">
          <div class="bgtit">
            So that&#39;s a brief guide for you to explore the DO ecology!
          </div>
          <div class="bgcon">
            Let&#39;s move on and you will find more surprises!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="less">
.w1352 {
  width: 1200px;
  margin: 0 auto;
}
.w1300 {
  width: 67%;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.userguide {
  width: 100%;
  overflow: hidden;
  background: #f2f5f9;

  .guide {
    background: url("../../../assets/pc/user/bg1.png") no-repeat;
    height: 720px;
    background-size: cover;
    .guide_w {
      width: 1190px;
      margin: 0 auto;
      .tit {
        height: 112px;
        font-family: Poppins, Poppins;
        font-weight: 900;
        font-size: 80px;
        color: #000000;
        line-height: 112px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-top: 131px;
      }
      .box {
        width: 1191px;
        height: 270px;
        background: linear-gradient(270deg, #e4efff 0%, #e8ddf9 100%);
        border-radius: 15px 15px 15px 15px;
        padding-top: 40px;
        margin-top: 32px;
        .boxtit {
          width: 1111px;
          height: 74px;
          font-family: Poppins, Poppins;
          font-weight: 700;
          font-size: 24px;
          color: #143d83;
          line-height: 37px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-left: 40px;
          //padding-top: 40px;
        }
        .boxtit1 {
          margin-top: 10px;
          margin-left: 40px;
          width: 967px;
          height: 30px;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 18px;
          color: #61666b;
          line-height: 30px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .boxtit3 {
          width: 303px;
          height: 50px;
          background: #4573e7;
          border-radius: 6px 6px 6px 6px;
          display: flex;
          margin-top: 26px;
          margin-left: 40px;
          .tits {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 18px;
            color: #ffffff;
            line-height: 50px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-left: 16px;
          }
          img {
            width: 20px;
            height: 20px;
            margin-top: 13px;
            margin-left: 10px;
          }
        }
      }
      .guidenum {
        display: flex;
        height: 34px;
        margin-top: 42px;
        .num {
          width: 60px;
          height: 32px;
          line-height: 32px;
          background: rgba(69, 115, 231, 0.3);
          border-radius: 5px 5px 5px 5px;
          font-family: Poppins, Poppins;
          font-weight: 700;
          font-size: 20px;
          color: #4573e7;
          line-height: 30px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .numtit {
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 20px;
          color: #333333;
          line-height: 34px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-left: 20px;
        }
      }
    }
  }
  .guide1 {
    margin-top: -200px;
    padding-bottom: 92px;
    .guide1-w {
      width: 1190px;
      margin: 0 auto;
      .guideul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .guideli {
          width: 581px;
          // height: 564px;
          background: #ffffff;
          border-radius: 15px 15px 15px 15px;
          padding-top: 30px;
          margin-bottom: 30px;
          padding-bottom: 28px;
          .litit1 {
            display: flex;
            margin-left: 40px;

            .step {
              width: 18px;
              height: 18px;
              background: #000000;
              border-radius: 137px 137px 137px 137px;
              font-family: Poppins, Poppins;
              font-weight: 800;
              font-size: 13px;
              color: #ffffff;
              line-height: 18px;
              text-align: center;
              font-style: normal;
              text-transform: none;
              margin-top: 8px;
              margin-right: 8px;
            }
            .steptit {
              height: 34px;
              font-family: Poppins, Poppins;
              font-weight: 700;
              font-size: 18px;
              color: #000000;
              line-height: 34px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
          }
          .litit2 {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 14px;
            color: #61666b;
            line-height: 25px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-left: 40px;
            margin-top: 6px;
          }
          .litit3 {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 14px;
            color: #4573e7;
            line-height: 33px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            height: 33px;
            background: rgba(69, 115, 231, 0.15);
            border-radius: 4px 4px 4px 4px;
            padding: 0px 10px;
            margin-left: 40px;
            margin-top: 6px;
          }
          img {
            width: 312px;
            height: 360px;
            margin-top: 24px;
            margin-left: 40px;
          }
          .img1 {
            width: 928px;
            height: 212px;
          }
          .img2 {
            width: 960px;
            height: 342px;
          }
          .img3 {
            width: 961px;
            height: 433px;
          }
          .img4 {
            width: 1080px;
            height: 320px;
          }
          .img5 {
            width: 960px;
            height: 490px;
          }
          .img3a1{
           width: 502px;
           height: 382px;
          }
          .img3a2 {
            // width: 502px;
            height: 382px;
          }
          .img3a2 {
            width: 751px;
            height: 386px;
          }
        }
      }
      .guidenum {
        display: flex;
        height: 34px;
        margin-top: 42px;
        .num {
          width: 60px;
          height: 32px;
          line-height: 32px;
          background: rgba(69, 115, 231, 0.3);
          border-radius: 5px 5px 5px 5px;
          font-family: Poppins, Poppins;
          font-weight: 700;
          font-size: 20px;
          color: #4573e7;
          line-height: 30px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .numtit {
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 20px;
          color: #333333;
          line-height: 34px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-left: 20px;
        }
      }
      .guidetit {
        height: 22px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 14px;
        color: #61666b;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-top: 13px;
      }
      .litit3 {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 14px;
        color: #4573e7;
        line-height: 33px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        height: 33px;
        background: rgba(69, 115, 231, 0.15);
        border-radius: 4px 4px 4px 4px;
        padding: 0px 10px;

        margin-top: 6px;
      }
      .guibg {
        background: url("../../../assets/pc/user/bg2.png") no-repeat;
        height: 191px;
        
        background-size: cover;
        .bgtit {
          height: 39px;
          font-family: Poppins, Poppins;
          font-weight: 700;
          font-size: 26px;
          color: #4573e7;
          line-height: 39px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-left: 103px;
          padding-top: 50px;
        }
        .bgcon {
          height: 24px;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 16px;
          color: #4573e7;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-left: 103px;
          padding-top: 39px;
        }
      }
    }
  }
}
</style>
